<script>
import formStepMixin from '@phoenix/mixins/formStepMixin';
import FormGroup from '@maison/components/form/FormGroup.vue';
import SelectField from '@maison/components/form/fields/SelectField.vue';
import DatePickerField from '@maison/components/form/fields/DatePickerField.vue';
import TextField from '@maison/components/form/fields/TextField.vue';
import IndividualNumberField from '@maison/components/form/fields/IndividualNumberField';

export default {
  components: {
    FormGroup,
    SelectField,
    DatePickerField,
    TextField,
    IndividualNumberField,
  },

  mixins: [formStepMixin],
};
</script>

<template>
  <div>
    <legend class="sr-only">{{ $t(`Form.gep.step3.label`) }}</legend>

    <h5 class="mb-8">{{ $t(`Form.gep.step3.title`) }}</h5>

    <div class="flex-grid flex-grid--y--md">
      <div class="w-full">
        <form-group :attrs="fields.collection">
          <select-field v-model="fields.collection.value" />
        </form-group>
      </div>

      <div class="w-full">
        <form-group :attrs="fields.reference">
          <text-field v-model="fields.reference.value" />
        </form-group>
      </div>

      <div class="w-full">
        <form-group :attrs="fields.acquisitionDate">
          <date-picker-field v-model="fields.acquisitionDate.value" />
        </form-group>
      </div>

      <div class="w-full">
        <form-group :attrs="fields.store">
          <select-field v-model="fields.store.value" />
        </form-group>
      </div>

      <div class="w-full">
        <form-group :attrs="fields.individualNumber">
          <individual-number-field v-model="fields.individualNumber.value" />
        </form-group>
      </div>
    </div>
  </div>
</template>
